import { render, staticRenderFns } from "./crosstab.vue?vue&type=template&id=6aa5a489&scoped=true"
import script from "./crosstab.vue?vue&type=script&lang=js"
export * from "./crosstab.vue?vue&type=script&lang=js"
import style0 from "./crosstab.vue?vue&type=style&index=0&id=6aa5a489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5a489",
  null
  
)

export default component.exports